export const AGE_BRACKETS = ["18 - 24", "25 - 30", "31 - 40", "40+"];

export const GENDERS = ["Male", "Female"];

export const RELIGIONS = [
  "Christianity",
  "Islam",
  "Traditional",
  "No Religion",
  "Other"
];

export const NATIONALITIES = [
  "Nigerian", 
  "Ghanaian",
  "Kenyan",
  "South African",
  "American",
  "British",
  "Canadian",
  "Other" 
];

export const WORK_ARRANGEMENTS = [
  { label: "Remote Worker", value: "Remote" },
  { label: "On-site Worker", value: "On-site" },
  { label: "Hybrid Worker", value: "Hybrid" }
];

export const SMOKING_HABITS = [
  { label: "Non-smoker", value: "Non-smoker" },
  { label: "Smoker", value: "Smoker" },
  { label: "Smoke Outside Only", value: "Outside Only" }
];

export const PARTY_HABITS = [
  { label: "Never", value: "Never" },
  { label: "Seldom", value: "Seldom" },
  { label: "From time to time", value: "Sometimes" }
];

export const COOKING_HABITS = [
  { label: "Never", value: "Never" },
  { label: "Sometimes", value: "Sometimes" },
  { label: "Frequently", value: "Frequently" }
];

export const PET_OPTIONS = [
  { label: "No Pets", value: "None" },
  { label: "Dog", value: "Dog" },
  { label: "Cat", value: "Cat" },
  { label: "Rabbit", value: "Rabbit" },
  { label: "Other", value: "Other" }
];

export const GENDER_PREFERENCES = [
  { label: "Male only", value: "Male" },
  { label: "Female only", value: "Female" },
  { label: "No Preference", value: "Any" }
];

export const HABIT_OPTIONS = [
  "Works from Home", "Clean-as-I-go", 
  "Weekend Cleaner", "Quiet & Reserved"
];

export const DISLIKE_OPTIONS = [
  "Loud Music/TV", "Frequent Parties", "Overnight Guests", 
  "Unwashed Dishes", "Messy Common Areas", "Sharing Groceries", 
  "Smoking Indoors", "Indoor Pets"
];